<template>
  <div>
    <Breadcrumbs main="Candidate" :title="`Assessment`" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
       <div class="row">
          <div class="col-xl-6 col-md-6 box-col-6" v-for="(item,idx) in listAsessment" :key="idx">
            <card-asessment :item="item.detail_insturction" :answer="listAnswer"></card-asessment>
          </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import CardAsessment from '../../components/asessment/CardAsessment.vue';
  import { getAsessment, getDataAnswer } from '../../_services/asessment.service';
  export default {
    components: { CardAsessment  },
    data() {
      return {
        listAsessment : [],
        listAnswer : []
      };
    },
    async created() {
      let listasessment = await getAsessment();
      let listAnswer = await getDataAnswer();
      this.listAsessment = listasessment.data;
      this.listAnswer = listAnswer;
    },
  };
</script>
